










































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import FormValidator from "@/mixins/FormValidator";
import RedStar from "@/components/ui/RedStar.vue";
import { AuthModule } from "@/store/auth.module";
import { DalModule } from "@/store/dal.module";
import { BaseModule } from "@/store/base.module";
import { EmailService } from "@/services/api/email.service";

@Component({
  components: { MonthPicker, RedStar },
})
export default class PersonalChangeView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
) {
  formRef = "formChangeEmail";
  email: string = null as any;
  loading: boolean = false;

  async saveData() {
    try {
      this.loading = true;
      if (!this.validateForm()) return;
      if (AuthModule.user && this.email === AuthModule.user.email) {
        BaseModule.showMessage({
          message: "change-email.nothing",
          color: "error",
        });
        return;
      }
      const checkExists = await DalModule.isExistEmail({ Email: this.email });
      if (checkExists && checkExists.result === true) {
        BaseModule.showMessage({
          message: "change-email.exists",
          color: "error",
        });
        return;
      }
      const { result, message } = await EmailService.changeEmail(this.email);
      if (result === true) {
        await AuthModule.getUser();
        BaseModule.showMessage({
          message: "change-email.EmailActivationInfo",
        });
        return;
      } else if (message)
        BaseModule.showMessage({
          message: message,
          color: "error",
        });
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await AuthModule.getUser();
    if (AuthModule.user) {
      this.email = AuthModule.user.email!;
    }
  }
}
